import { combineReducers } from 'redux';

import byDealerId from './byDealerId';
import byId from './byId';

export default combineReducers({
  byId,
  byDealerId,
});
